import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export type Tab = 'inbox' | 'pinned' | 'snoozed' | 'muted';

interface Props {
    active: Tab;
    counts: { inbox: number; pinned: number; snoozed: number; muted: number };
    onChange: (tab: Tab) => void;
}

const TABS: { key: Tab; labelId: string; defaultLabel: string }[] = [
    { key: 'inbox',   labelId: 'notifications.tabs.inbox',   defaultLabel: 'Inbox' },
    { key: 'pinned',  labelId: 'notifications.tabs.pinned',  defaultLabel: 'Pinned' },
    { key: 'snoozed', labelId: 'notifications.tabs.snoozed', defaultLabel: 'Snoozed' },
    { key: 'muted',   labelId: 'notifications.tabs.muted',   defaultLabel: 'Muted' },
];

/**
 * Primary segmentation at the top of the feed: Inbox / Pinned / Snoozed / Muted.
 * Different from the left-rail filters — tabs change WHAT you're looking at
 * (organizational state), filters narrow within the current tab. Active tab
 * gets a navy underline and bold weight.
 *
 * The Muted tab is special: it shows notifications whose SOURCE is actively
 * muted, the inverse of what the other tabs show. Surfaces what would
 * otherwise be invisible — so users can rediscover and one-click unmute.
 */
const NotificationTabs: React.FC<Props> = ({ active, counts, onChange }) => (
    <div className="notif-tabs" role="tablist">
        {TABS.map((tab) => (
            <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={active === tab.key}
                className={`notif-tabs__tab ${active === tab.key ? 'is-active' : ''} ${tab.key === 'muted' ? 'notif-tabs__tab--muted' : ''}`}
                onClick={() => onChange(tab.key)}
            >
                <span className="notif-tabs__tab-label">
                    <FormattedMessage id={tab.labelId} defaultMessage={tab.defaultLabel} />
                </span>
                <span className="notif-tabs__tab-count">{counts[tab.key]}</span>
            </button>
        ))}
    </div>
);

export default NotificationTabs;
